<template>

  <div class="order home">

    <van-nav-bar :title="$t('订单历史记录')" class="nav-bar" >
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>

    </van-nav-bar>
    <van-loading size="24px" vertical v-show="loading">{{$t('加载中')}}...</van-loading>
    <van-tabs v-model="active"  @change="initData" type="card" >
      <van-tab v-for="item in status_data" :key="item.value" :title="item.label">
        <div class="list" v-for="info in list" :key="info.id"  @click="tjOrder(info)">
          <div class="top">
            <span class="time">{{info.addtime}}</span>
            <div class="number">{{info.id}}</div>
          </div>
          <div class="cet aaa">
            <img :src="info.goods_pic" class="img" alt="">
            <div class="text">
              {{info.goods_name}}
              <div class="tab" :class="info.status == -1">
                <span class="span" v-if="info.status == 0">{{ $t('待提交') }}</span>
                <span class="span" v-if="info.status == 1">{{ $t('已提交') }}</span>
              </div>
            </div>
          </div>
          <div class="monney">


            <div class="tent" >
              <span class="span">{{$t('总金额')}}</span>
              <span class="value">{{$store.getters.getBaseInfo.currency+info.num}}</span>
            </div>
            <div class="tent">
              <span class="span">{{$t('佣金')}}</span>
              <span class="value">{{$store.getters.getBaseInfo.currency+info.commission}}</span>
            </div>
            <div class="tent" >
              <span class="span">{{ $t('差额') }} </span>
              <span class="value">{{$store.getters.getBaseInfo.currency+info.need  }}</span>
            </div>
          </div>
        </div>
        <van-empty   v-if="list.length == 0" :description="$t('目前没有订单')" />
      </van-tab>
    </van-tabs>

    <van-dialog v-model="showTj" :confirmButtonText="$t('确定')" :cancelButtonText="$t('取消')"
                :show-confirm-button="true" :title="$t('订单详情')" show-cancel-button @confirm="confirmPwd()">
      <template #title>
        <div style="text-align: center">{{ $t('订单详情') }}</div>
      </template>
      <div class="list" >
        <div style="text-align: center;" v-if="onceinfo.need > 0">
          <div style="color:#fde259;">{{ $t("幸运订单") }}</div>
          <div style="margin-top: 10px;background: #fde259;color: red; border-radius: 5px;padding: 10px;font-size: 28px">{{ $t("完成订单还需额外支付100").replace("100",  $store.getters.getBaseInfo.currency + onceinfo.need) }}</div>
        </div>
        <div class="cet" style="margin-top: 10px">
          <img :src="onceinfo.goods_pic" class="img" alt="">
        </div>
        <div class="monney">

          <div style="text-align: center;margin-bottom: 10px">
            {{ onceinfo.goods_name }}
          </div>

          <div class="tent">
            <span class="span">{{ $t('订单号') }}</span>
            <span class="value">{{ onceinfo.oid }}</span>
          </div>
          <div class="tent">
            <span class="span">{{ $t('抢单时间') }}</span>
            <span class="value">{{ onceinfo.addtime }}</span>
          </div>

          <div class="tent" >
            <span class="span">{{ $t('差额') }}</span>
            <span class="value">{{ $store.getters.getBaseInfo.currency + onceinfo.difference }}</span>
          </div>

          <div class="tent">
            <span class="span">{{ $t('总金额') }}</span>
            <span class="value">{{ $store.getters.getBaseInfo.currency + onceinfo.num }}</span>
          </div>
          <div class="tent">
            <span class="span">{{ $t('佣金') }}</span>
            <span class="value">{{ $store.getters.getBaseInfo.currency + onceinfo.commission }}</span>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      showTj:false,
      num: 0,
      onceinfo: {},
      loading:false,
      active: 0,
      page: 1,
      showConfirm: false,
      nowTime: new Date().getTime(),
      list:[],
      status_data:[
        {label: this.$t('待提交'),value: 1},
        {label: this.$t('已提交'),value: 3},
      ]
    }
  },
  methods: {

    back() {
      return window.history.back();
    },
    initData() {
      const info = {
        status: this.status_data[this.active].value || '',
        page: this.page,
        size: 50
      }
      this.$http({
        method: 'post',
        data: info,
        url: 'get_order_list'
      }).then(res => {
        this.list = res.data;
        /*if (res.status == 5) {
          this.list = res.data.list.filter(rr => {
            if (rr.duorw > 0 && rr.time_limit < 1) {
              return true
            } else {
              return rr.status == 5
            }
          })
        } else {
          this.list = res.data.list.map(rr => {
            if (rr.status == 5 && rr.is_pay === 1 && rr.duorw > 0) {
              rr.status = 0
            }
            return rr
          })
        }*/
      })
    },
    tjOrder(info){
      if(info.status != 0){
          return false;
      }
      this.num = 0;
      this.$http({
        method: 'post',
        data:{
          oid: info.id
        },
        url: 'order_info'
      }).then(res=>{
        if(res.code == 200){
          this.loading = false
          this.onceinfo = res.data
          this.showTj = true
        }else {
          this.$toast(this.$t(res.msg));
        }
      })
    },
    confirmPwd() {
      this.$http({
        method: 'post',
        data:{
          oid: this.oid,
          status: 1,
          num: 5
        },
        url: 'do_order'
      }).then(res=>{
        this.$toast(this.$t(res.msg).replace("100",this.$store.getters.getBaseInfo.currency + res.data));
        if(res.code == 200){
          this.showTj = false
          this.getUserInfo();
        }
      })

    }
  },
  created() {
    this.initData()
  }
}
</script>

<style scoped>
.nav-bar {
  background: linear-gradient(30deg, #e62978, #d63f8c);
}
::v-deep .van-dialog__cancel{
  height: 100px;
  line-height: 100px;
  font-size: 32px;
}
::v-deep .van-dialog__confirm{

  height: 100px;
  line-height: 100px;
  font-size: 32px;
}
.van-button {
  font-size: 28px;
  margin-top: 50px;
}
::v-deep .van-tabs--card>.van-tabs__wrap{
  margin-top: 20px;
  height: 100px;
}
::v-deep .van-tab{
  height: 100px;
  line-height: 100px;
  font-size: 28px;
}

::v-deep .van-tabs__nav--card{
  width: 100%;
  line-height: 1;
  color: #fff !important;
  font-size: 15px;
  text-align: center;
  background-color: #fafafa!important;
  border: none !important;
  height: 100px;

}

.home{
  padding-top: calc(var(--van-nav-bar-height) + 0vw)!important;
  z-index: 10;
}
::v-deep .van-empty{
  margin-top: 100px;
}
.order{
  padding: calc(var(--van-nav-bar-height) + 30px) 0 0;
  background-color: #f5f5f5;

::v-deep(.van-nav-bar){

  padding: 0!important;
}

::v-deep .van-nav-bar__title{
  color: #fff;
}
::v-deep .van-tabs__wrap{
  background-color: #f5f5f5;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
::v-deep(.van-nav-bar__content){
  background-color: #191919;
  padding: 0!important;
}
::v-deep(.van-tab__panel){
  padding: 0 var(--van-padding-md);
}
::v-deep(.van-tabs){
.van-tab--card{
  width: 40%;
  margin: 0 10px;
  height: 2.4rem;
  line-height: 1;
  color: #232f3e;
  font-size: 0.85rem;
  text-align: center;
  border: 1px solid #000000;
  border-radius: 10px;
  position: relative;
  background: #ffffff;
  border: 1px solid #000000;

}
.van-tab--active{
  width: 40%;
  height: 2.4rem;
  line-height: 1;
  color: #fff;
  font-size: 0.85rem;
  text-align: center;
  border: 1px solid #232f3e;
  border-radius: 10px;
  position: relative;
  background: #fe2c55;
  border: 1px solid #fe2c55;
}
}
.van-submit-bar{
  bottom: 88px;
}
::v-deep(.van-button--danger){
  border-radius: 80px !important;
}
::v-deep(.van-submit-bar__price){
  color: #02b2d6;
}

.van-dialog{
  width: 80%;
  font-size: 28px;
}
::v-deep(.van-dialog){
.van-dialog__header{
  text-align: left;
  padding: 20px 40px;
  font-weight: 600;
}
.list{
  padding: 0 40px;
  box-shadow: none;
  max-height: 60vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
.tops {
  margin-bottom: 0;
  color: #333;
.span {
  margin-right: 24px;
}
}
.box{
  padding: 15px;
  border: 2px solid #ccc;
  margin-top: 24px;
&:first-child{
   margin-top: 0;
 }
.value0 {
  padding: 3px 10px;
  background-color: red;
  color: #fff;
}
.value1 {
  padding: 3px 10px;
  background-color: #07c160;
  color: #fff;
}
}
}
.van-dialog__footer{
  margin-top: 40px;
.van-dialog__confirm{
  color: #02b2d6;
}
}
}
}
.colon {
  display: inline-block;
  margin: 0 4px;
  color: #02b2d6;
}
.block {
  display: inline-block;
  width: 35px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background-color: #02b2d6;
}
.list{
  padding: 30px;
  box-shadow: 0 0 20px 0 #e9e9e9;
  color:  #999;
  text-align: left;
  margin-top: 20px;
  border-radius: 10px;
  background-color: #fff;
.top{
  display: flex;
  justify-content: space-between;
  margin-bottom: 35px;
  font-size: 24px;
.time{
  font-size: 24px;
}
}
.cet{
  display: flex;
  background-color: #fafafa;
  padding: 10px 0;
&.aaa{
.img{
  width: auto;
  height: 150px;
  margin-right: 20px;
}
}
.img{
  width: 100%;
  height: 180PX;
}
.text{
  color: #333;
  font-size: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
.tab{
  display: inline-block;
  text-align: left;
  margin-top: 5px;
.span {
  padding: 2px 10px;
  border: 1px solid red;
  color: red;
}
}
.tent{
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
}
}
.monney{
  margin-top: 30px;
.tent{
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  margin-top: 15PX;
  color: #333;
.span{
  color: #333;
}
.van-count-down{
  color: red;
}
.value{
  color: #999;
}
}
}
.van-button{
  font-size: 32px;
  margin-top: 50px;
  border-radius: 0;
  padding: 10PX 15PX;
  height: auto;
  border-radius: 4.333333vw;
}

}

.list {
  padding: 30px;
  box-shadow: 0 0 20px 0 #e9e9e9;
  color: #999;
  text-align: left;
  margin-top: 20px;
  border-radius: 10px;

.top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 35px;

.time {
  font-size: 24px;
}

.tab {
  font-size: 20px;
  color: #02b2d6
}

}

.cet {
  display: flex;
  background-color: #fafafa;
  padding: 10px 0;

.img {
  width: 100%;
  height: 180PX;
}

.text {
  font-size: 28px;
}

}

.monney {
  margin-top: 30px;

.tent {
  display: flex;
  justify-content: space-between;
  font-size: 28px;

.span {
  color: #333;
}

}
}
}
</style>